import { render, staticRenderFns } from "./communityPaymentList.vue?vue&type=template&id=c0ff6728&scoped=true"
import script from "./communityPaymentList.vue?vue&type=script&lang=js"
export * from "./communityPaymentList.vue?vue&type=script&lang=js"
import style0 from "./communityPaymentList.vue?vue&type=style&index=0&id=c0ff6728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff6728",
  null
  
)

export default component.exports